import { ObjectElementFactory } from "../ObjectElementFactory";
import { TextareaElement } from "./TextareaElement";
import { ElementRegistry } from "../ElementRegistry";
/**
 * Textarea Element Factory
 */
export class TextareaElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new TextareaElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register('textarea', new TextareaElementFactory());
})();
//# sourceMappingURL=TextareaElementFactory.js.map